export const contentTableConfig = {
  title: '直播间商品管理',
  propList: [
    {
      prop: 'liveRoom',
      label: '所属直播间',
      minWidth: '80',
      slotName: 'liveRoom'
    },
    {
      prop: 'name',
      label: '商品名称',
      minWidth: '120'
    },
    {
      prop: 'cover',
      label: '商品图片',
      minWidth: '80',
      slotName: 'cover'
    },
    {
      prop: 'price',
      label: '商品价格',
      minWidth: '80'
    },
    {
      prop: 'payQrCode',
      label: '支付二维码',
      minWidth: '80',
      slotName: 'payQrCode'
    },
    // {
    //   prop: 'initSellNum',
    //   label: '初始已售卖量',
    //   minWidth: '80'
    // },
    {
      prop: 'isShow',
      label: '是否上架',
      minWidth: '80',
      slotName: 'isShow'
    },
    {
      prop: 'hotSell',
      label: '上热卖',
      minWidth: '80',
      slotName: 'hotSell'
    },
    {
      prop: 'updateTime',
      label: '更新时间',
      minWidth: '80'
    },
    {
      label: '操作',
      minWidth: '100',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
